import { cn } from '@/lib/cn';

import { FormattedField, FormattedFieldId } from '../model/ConfirmationDto';

type InfoTableProps = {
    fields: FormattedField[];
    shouldWarnAboutStart?: boolean;
};

export const InfoTable = ({
    fields,
    shouldWarnAboutStart = false,
}: InfoTableProps) => {
    return (
        <table>
            <tbody>
                {fields.map(({ Id, Title, Value }, idx) => {
                    const shouldAddWarningBackground =
                        Id === FormattedFieldId.ScheduledOn &&
                        shouldWarnAboutStart;
                    return (
                        <tr
                            key={idx}
                            className={cn({
                                'bg-(--color-bg-danger-subtle)':
                                    shouldAddWarningBackground,
                            })}
                        >
                            <th className="pt-2 pr-4 font-bold whitespace-nowrap">
                                {Title}
                            </th>
                            <td className="pt-2 font-normal">{Value}</td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};
